function Intent() {
	const self = this;
	let timer;

	this.exec = function (callback, duration, ...args) {
		self.clear();
		timer = setTimeout(callback.bind(this, args), duration || 1000);
	};

	this.clear = function () {
		clearTimeout(timer);
	};

}
export default Intent;



// WEBPACK FOOTER //
// ./mobile-core/src/utils/intent.js